import { render, staticRenderFns } from "./prevthree.vue?vue&type=template&id=0ebaf0fa&"
import script from "./prevthree.vue?vue&type=script&lang=ts&"
export * from "./prevthree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports